<template>
  <div class="restriction">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Restriction'
}
</script>
